module.exports = __webpack_public_path__ + "threeCover.971e175ee1d79a832b2a.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/three/threeCover.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/three/threeCover.jpg
// module chunks = 0